// components/CuisineFilter.jsx
import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

const CuisineFilter = ({ cuisines, selectedCuisines, onCuisineChange }) => {
  const handleCuisineClick = (cuisineId) => {
    if (selectedCuisines.includes(cuisineId)) {
      onCuisineChange(selectedCuisines.filter(id => id !== cuisineId));
    } else {
      onCuisineChange([...selectedCuisines, cuisineId]);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ color: '#FFD700', mb: 1 }}>
        Filter by cuisine
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {cuisines.map((cuisine) => (
          <Chip
            key={cuisine.id}
            icon={<span>{cuisine.icon}</span>}
            label={cuisine.name}
            onClick={() => handleCuisineClick(cuisine.id)}
            sx={{
              backgroundColor: selectedCuisines.includes(cuisine.id) ? '#FFD700' : '#1A1A1A',
              color: selectedCuisines.includes(cuisine.id) ? '#000000' : '#FFFFFF',
              border: '1px solid #FFD700',
              '&:hover': {
                backgroundColor: '#FFD700',
                color: '#000000'
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CuisineFilter;